/** Shared onboarding step indices and answer helpers. */

export const STEP_INDUSTRY = 0;
export const STEP_LOCATION = 1;
export const STEP_REVENUE = 2;
export const STEP_ACTIONS = 3;
export const STEP_CRM = 4;
export const STEP_NAME = 5;
export const STEP_COUNT = 6;

export const resolveIndustryInclude = (industryInclude, otherSelected, otherIndustries) => {
  const featured = [...(industryInclude || [])];
  if (!otherSelected) return featured;

  const extras = (otherIndustries || []).filter(Boolean);
  const seen = new Set(featured);
  extras.forEach((label) => {
    if (!seen.has(label)) {
      seen.add(label);
      featured.push(label);
    }
  });
  return featured;
};
